// extracted by mini-css-extract-plugin
export var arrows = "_85-6";
export var decrementer = "_85-a";
export var disabled = "_85-4";
export var error = "_85-1";
export var hiddenText = "_85-b";
export var incrementer = "_85-9";
export var input = "_85-8";
export var inputWrapper = "_85-0";
export var leadingIcon = "_85-c";
export var readonly = "_85-3";
export var regular = "_85-7";
export var small = "_85-5";
export var warning = "_85-2";